import React, { useState, useEffect } from 'react';
import { X, ArrowUp } from 'lucide-react';
import { APP_STORE_URL, PLAY_STORE_URL } from '../../mock';

export default function AppDownloadBadges() {
  const [open, setOpen] = useState(true);
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 400);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <>
      {open && (
        <div className="fixed bottom-5 right-5 z-40 flex flex-col items-end gap-2">
          <div className="relative rounded-2xl bg-white shadow-2xl border border-pink-100 p-3 pr-8 flex flex-col gap-2 animate-fadeUp">
            <button
              onClick={() => setOpen(false)}
              aria-label="close"
              className="absolute top-2 right-2 h-6 w-6 grid place-items-center rounded-full text-slate-400 hover:text-slate-800 hover:bg-slate-100"
            >
              <X size={14} />
            </button>
            <div className="text-xs font-semibold text-slate-800 px-1">Get the Zoopers app</div>
            <a
              href={APP_STORE_URL}
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center gap-2 bg-black hover:bg-slate-800 text-white rounded-xl px-3 py-2 transition-colors"
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/></svg>
              <span className="text-xs font-semibold">App Store</span>
            </a>
            <a
              href={PLAY_STORE_URL}
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center gap-2 bg-black hover:bg-slate-800 text-white rounded-xl px-3 py-2 transition-colors"
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M3.18 23.76a2.07 2.07 0 0 0 .47.24l10.3-10.3-2.97-2.97L3.18 23.76zM20.52 10.4l-2.8-1.6-3.35 3.22 3.35 3.35 2.8-1.62a2.09 2.09 0 0 0 0-3.35zM3 .24a2.09 2.09 0 0 0-.47.24L10.98 9l2.97-2.97L3 .24zM14.25 12 3.65 22.6a2 2 0 0 0 1.2-.2l11.73-6.78-2.33-2.62z"/></svg>
              <span className="text-xs font-semibold">Google Play</span>
            </a>
          </div>
        </div>
      )}
      {showTop && (
        <button
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          className="fixed bottom-5 left-5 z-40 h-11 w-11 grid place-items-center rounded-full bg-[#E91E80] text-white shadow-lg hover:bg-[#D1176E] transition-colors"
        >
          <ArrowUp size={18} />
        </button>
      )}
    </>
  );
}
